<template>
  <b-form class="form-register-detail" @submit="onSubmit" @reset="onReset">
    <h1 :style="{ fontSize: '22px', fontWeight: 700 }">
      Account Details
    </h1>
    <b-form-group id="group-password">
      <slot name="label">
        <label
          class="font-weight-bold mb-1"
          for="input-password"
          :style="{ fontSize: '14px' }"
          >Password</label
        >
      </slot>
      <slot name="description">
        <div class="text-muted" :style="{ fontSize: '13px' }">
          Note: Password should have at least 6 characters
        </div>
      </slot>
      <div class="position-relative">
        <b-form-input
          id="input-password"
          v-model="form.password"
          :class="['password-input']"
          :type="inputPasswordType"
          required
          placeholder="Enter your password"
        ></b-form-input>
        <a
          class="position-absolute password-control"
          href="javascript:;"
          role="button"
          @click="handleIsShowPassword"
        >
          <span v-if="'password' === inputPasswordType">Show</span>
          <span v-else-if="'text' === inputPasswordType">Hide</span>
        </a>
      </div>
    </b-form-group>
    <b-form-group id="group-country">
      <label
        class="font-weight-bold mb-1"
        for="input-country"
        :style="{ fontSize: '14px' }"
        >Country/Region</label
      >
      <b-form-select
        id="input-country"
        v-model="form.profile.country_id"
        :options="countryOptions"
        required
      ></b-form-select>
    </b-form-group>

    <b-form-group id="group-option">
      <label
        class="font-weight-bold mb-1"
        for="input-option"
        :style="{ fontSize: '14px' }"
        >Field of Study/Profession (optional)</label
      >
      <slot name="description">
        <div class="text-muted" :style="{ fontSize: '13px' }">
          i.e. Engineering, Math, Marketing. Use comma to add more terms.
        </div>
      </slot>
      <vue-tags-input
        v-model="tag"
        :placeholder="''"
        :add-on-key="[13, ',']"
        @tags-changed="handleTagsChanged"
      />
    </b-form-group>

    <b-form-checkbox
      class="mb-3"
      id="checkbox-1"
      v-model="form.agree_terms"
      :style="{ fontSize: '14px' }"
    >
      I agree to CourseNetworking's
      <a :href="`${cnUrl}/policy`" target="_blank" title="Terms of Service"
        >Terms of Service</a
      >
      and
      <a :href="`${cnUrl}/tos`" target="_blank" title="Privacy Policy"
        >Privacy Policy</a
      >
    </b-form-checkbox>

    <b-form-group>
      <b-button
        class="btn-submit btn-success"
        type="submit"
        variant="primary"
        :disabled="!form.agree_terms"
        >Create Free Account</b-button
      >
    </b-form-group>

    <b-modal ref="my-modal" title="Message">
      <p v-text="message"></p>
    </b-modal>
  </b-form>
</template>

<script>
import _ from "lodash";
import { mapState, mapGetters, mapMutations } from "vuex";
import { SET_USER } from "@/store/mutation-types";
import { CN_HOST, CN_API_ROOT } from "@/configs";
import VueTagsInput from "@johmun/vue-tags-input";
import md5 from "md5";

const COUNTRY_DEFAULT_OPTIONS = [
  { value: null, text: "Please select an option" }
];

const FORM_DEFAULT = {
  password: "",
  profile: {
    country_id: null,
    major_interests: []
  },
  agree_terms: 0
};
export default {
  name: "form-register-detail",
  components: { VueTagsInput },
  props: {
    cnUrl: {
      type: String,
      default: CN_HOST
    }
  },
  data() {
    return {
      tag: "",
      countryDataOptions: [],
      inputPasswordType: "password",
      form: Object.assign({}, FORM_DEFAULT),
      message: ""
    };
  },
  computed: {
    countryOptions: {
      get: function() {
        return [].concat(COUNTRY_DEFAULT_OPTIONS, this.countryDataOptions);
      }
    },
    password: {
      get: function() {
        return md5(this.form.email).slice(0, 10);
      }
    }
  },
  methods: {
    ...mapMutations("user", [SET_USER]),
    handleTagsChanged(newTags) {
      this.$set(
        this.form.profile,
        "major_interests",
        newTags.map(tag => tag.text)
      );
    },
    handleIsShowPassword() {
      this.inputPasswordType =
        "password" === this.inputPasswordType ? "text" : "password";
    },
    resetForm() {
      this.form = Object.assign({}, FORM_DEFAULT);
    },
    onSubmit(evt) {
      this[SET_USER](Object.assign(this.form));
      this.$emit("submit");
      evt.preventDefault();
    },
    onReset(evt) {
      evt.preventDefault();
    }
  },
  mounted() {
    this.$http
      .get(`${CN_API_ROOT}/country`, {
        params: {
          limit: 300
        }
      })
      .then(ctx => {
        const { data } = ctx;
        let countryData = _.get(data, "data");
        let countries = [];
        if (countryData.length) {
          countries = countryData.map(c => {
            return {
              value: c.id,
              text: c.name
            };
          });
        }
        this.countryDataOptions = countries;
      })
      .catch();
  }
};
</script>
<style lang="css">
.form-register-detail .vue-tags-input {
  width: 100% !important;
  max-width: 100% !important;
}
.form-register-detail .vue-tags-input .ti-input {
  border-radius: 0.25rem !important;
}
.form-register-detail .vue-tags-input .ti-input .ti-tag {
  background-color: #efeff9 !important;
  color: #3674d9 !important;
}
.form-register-detail .vue-tags-input .ti-input .ti-tag:hover {
  background-color: #e6e4ef !important;
}
.password-control {
  right: 0px;
  bottom: 0px;
  padding: 9px;
  font-size: 14px;
}
.password-input {
  padding-right: 50px;
}
</style>
